import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Price } from '../types/pricing.types';

@Injectable()
export class PricingFormService
{
  private _pricingForm: FormGroup;
  constructor(private _formBuilder: FormBuilder)
  {
    this._buildForm();
  }

  get form()
  {
    return this._pricingForm;
  }

  get addonsFA()
  {
    return this._pricingForm.get('Addons') as FormArray;
  }

  setAddonsFA(addons: Price[])
  {
    this.addonsFA.clear();

    for (let addon of addons)
    {
      this.addonsFA.push(this._createAddonFG(addon));
    }
  }

  private _buildForm()
  {
    this._pricingForm = this._formBuilder.group({
      ProductId: [null],
      Addons: this._formBuilder.array([]),
    });
  }

  private _createAddonFG(addon: Price)
  {
    return this._formBuilder.group({
      Quantity: [addon.Quantity || 1],
      Checked: [addon.Checked || false],
      ProductId: [addon.ProductId],
      Name: [addon.Name],
      PriceId: [addon.PriceId],
      Taxes: [addon.Taxes],
      Unit: [addon.Unit],
      UnitAmount: [addon.UnitAmount],
      Interval: [addon.Interval],
      Metadata: [addon.Metadata],
      Order: [addon.Order],
    });
  }
}
